/* Wander Painting product page (paint by numbers): option cards that drive Kaching / Dawn,
   live price, delivery date estimate, small toggles. */
(() => {
  const money = (cents) => {
    const fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: fmt }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  class WpPdpOptions extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.steps = Array.from(this.querySelectorAll('fieldset[data-option-index]'));
      const first = this.variants.find((v) => v.available) || this.variants[0];
      this.state = first.options.slice();
      // start from what's already selected (URL ?variant= or Dawn default)
      const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      const pre = idInput && this.variants.find((v) => String(v.id) === String(idInput.value));
      if (pre) this.state = pre.options.slice();

      this.steps.forEach((step) => {
        const idx = Number(step.dataset.optionIndex);
        step.querySelectorAll('.wpp-card').forEach((card) => {
          card.addEventListener('click', () => this.choose(idx, card.dataset.value));
        });
      });
      this.querySelectorAll('[data-wpp-open]').forEach((b) => b.addEventListener('click', () => {
        const dlg = document.getElementById(b.getAttribute('aria-controls'));
        if (!dlg) return;
        if (dlg.parentElement !== document.body) document.body.appendChild(dlg); // escape transformed parents
        dlg.querySelectorAll('img[loading="lazy"]').forEach((i) => { i.loading = 'eager'; }); // popup images load on first open
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
        document.documentElement.classList.add('wpp-modal-open');
      }));
      document.querySelectorAll('.wpp-modal').forEach((dlg) => {
        const close = () => { dlg.close ? dlg.close() : dlg.removeAttribute('open'); };
        dlg.addEventListener('close', () => document.documentElement.classList.remove('wpp-modal-open'));
        dlg.querySelectorAll('[data-wpp-close]').forEach((x) => x.addEventListener('click', close));
        dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); }); // click on backdrop
      });

      // Kaching re-renders its bars (e.g. when switching Starter/Professional): re-apply our choice.
      document.addEventListener('change', (e) => {
        const s = e.target;
        if (!s.matches || !s.matches('select.kaching-bundles__bar-variant-select') || this.applying) return;
        const v = s.value;
        this.steps.forEach((step) => {
          const idx = Number(step.dataset.optionIndex);
          if (Array.from(step.querySelectorAll('.wpp-card')).some((c) => c.dataset.value === v)) this.state[idx] = v;
        });
        this.render();
      }, true);
      const mo = new MutationObserver(() => {
        clearTimeout(this.moTimer);
        this.moTimer = setTimeout(() => this.syncKaching(), 120);
      });
      const root = document.querySelector('.product__info-container') || document.body;
      mo.observe(root, { childList: true, subtree: true });

      this.render();
      setTimeout(() => this.syncKaching(), 800);
    }

    variantFor(opts) {
      return this.variants.find((v) => v.options.every((o, i) => o === opts[i]));
    }

    choose(idx, value) {
      this.state[idx] = value;
      this.render(true);
      this.syncKaching();
      this.syncDawn();
    }

    render(updateUrl = false) {
      this.steps.forEach((step) => {
        const idx = Number(step.dataset.optionIndex);
        step.querySelectorAll('.wpp-card').forEach((card) => {
          const active = card.dataset.value === this.state[idx];
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-pressed', String(active));
          const opts = this.state.slice();
          opts[idx] = card.dataset.value;
          const v = this.variantFor(opts);
          const priceEl = card.querySelector('[data-price]');
          card.classList.toggle('is-unavailable', !v || !v.available);
          if (priceEl && v) priceEl.textContent = money(v.price);
        });
      });
      const v = this.variantFor(this.state);
      if (v) {
        document.querySelectorAll('[data-wpp-price]').forEach((el) => (el.textContent = money(v.price)));
        document.querySelectorAll('[data-wpp-compare]').forEach((el) => {
          el.hidden = !(v.compare > v.price);
          if (v.compare > v.price) el.textContent = money(v.compare);
        });
        const url = new URL(window.location.href);
        if (updateUrl && url.searchParams.get('variant') !== String(v.id)) {
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }

    // Set every Kaching variant select that offers one of our values.
    syncKaching() {
      const selects = document.querySelectorAll('select.kaching-bundles__bar-variant-select');
      if (!selects.length) return;
      this.applying = true;
      selects.forEach((s) => {
        const values = Array.from(s.options).map((o) => o.value);
        const want = this.state.find((val) => values.includes(val));
        if (want && s.value !== want) {
          s.value = want;
          s.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      this.applying = false;
    }

    // Fallback without Kaching: drive Dawn's variant picker.
    syncDawn() {
      if (document.querySelector('select.kaching-bundles__bar-variant-select')) return;
      const vs = document.querySelector('variant-selects');
      if (!vs) return;
      this.state.forEach((val) => {
        const input = Array.from(vs.querySelectorAll('input[type=radio]')).find((i) => i.value === val);
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  }
  if (!customElements.get('wp-pdp-options')) customElements.define('wp-pdp-options', WpPdpOptions);

  // Delivery estimate: business days → date range
  const addBusinessDays = (date, n) => {
    const d = new Date(date);
    let added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      const wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  };
  document.querySelectorAll('[data-wpp-delivery]').forEach((el) => {
    const min = Number(el.dataset.min), max = Number(el.dataset.max);
    const fmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
    const eta = el.querySelector('[data-wpp-eta]');
    if (eta && min && max) eta.textContent = fmt.format(addBusinessDays(new Date(), min)) + ' – ' + fmt.format(addBusinessDays(new Date(), max));
  });
})();
